import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { trans } from '../../../localization/language';
import * as emailActions from '../../../actions/email';
import { encryptPassword } from '../../../utils';
import { STATUS_CODE } from '../../../constants';

class ChangeEmail extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			newEmailError: null,
			confirmEmailError: null,
			passwordError: null,
			newEmail: '',
			confirmEmail: '',
			password: '',
		};
	}

	handleSubmit(event) {
		event.preventDefault();
		if (this.validateInputs()) {
			var encryptedPassword = encryptPassword(this.state.password);
			this.props.saveEmail(this.state.newEmail, encryptedPassword, this.props.language.lang);
		}
	}

	handleChangeNewEmail(event) {
		this.setState({newEmail: event.target.value});
	}

	handleChangeConfirmEmail(event) {
		this.setState({confirmEmail: event.target.value});
	}

	handleChangeCurrentPassword(event) {
		this.setState({password: event.target.value});
	}
	
	validateInputs() {
		this.setState({
			newEmailError: null,
			confirmEmailError: null,
			passwordError: null
		});
		if (!this.checkEmail(this.state.newEmail)) {
			this.setState({newEmailError: trans('error_email_invalid')});
			return false;
		}
		if (this.state.newEmail === this.props.userInfo.email) {
			this.setState({newEmailError: trans('error_email_same')});
			return false;
		}
		if(this.state.newEmail != this.state.confirmEmail) {
			this.setState({confirmEmailError: trans('error_email')});
			return false;
		}
		if (!this.state.password) {
			this.setState({passwordError: trans('error_password_required')});
			return false;
		}
		return true;
	}

	checkEmail(email) {
		if(!email || !/^[\w\-+.%]+@[\w\-.]+\.\w+$/.test(email)) {
			return false;
		}
		return true;
	}
	
	getNewEmailError() {
		if (this.state.newEmailError) {
			return (
				<div className="content__form-errmsg-item content__form-errmsg-item--visible">
					{this.state.newEmailError}
				</div>
			);
		} else if (this.props.email.status == STATUS_CODE.EMAIL_EXISTS) {
			return (
				<div className="content__form-errmsg-item content__form-errmsg-item--visible">
					{trans('error_email_existed')}
				</div>
			);
		} else if (this.props.email.status == STATUS_CODE.OTP_LIMIT_EXCEEDED) {
			return (
				<div className="content__form-errmsg-item content__form-errmsg-item--visible">
					{trans('send_email_error')}
				</div>
			);
		}
	}

	getConfirmEmailError() {
		if (this.state.confirmEmailError) {
			return (
				<div className="content__form-errmsg-item content__form-errmsg-item--visible">
					{this.state.confirmEmailError}
				</div>
			);
		}
	}

	getPasswordError() {
		if (this.state.passwordError) {
			return (
				<div className="content__form-errmsg-item content__form-errmsg-item--visible">
					{this.state.passwordError}
				</div>
			);
		} else if (this.props.email.status == STATUS_CODE.INCORRECT_PASSWORD) {
			return (
				<div className="content__form-errmsg-item content__form-errmsg-item--visible">
					{trans('error_verify_password')}
				</div>
			);
		}
	}

	render() {
		return (
			<div className="content">
				<div className="content-item content-item--ipage">
					<div className="content-item__title">
						{(this.props.userInfo.email === '') ? trans('add_email_title') : trans('change_email_title')}
					</div>
					<div className="content-item__main">
						<div className="content-item--ipage__main">
							<div className="content__form">
								<form method="post" action="" id="J-validated-form" onSubmit={this.handleSubmit.bind(this)}>
									<div className="content__form-input">
										<input type="email" className="content__form-input-widget J-validated-field"
											id="J-form-newemail" placeholder={trans('new_email_placeholder')}
											onChange={this.handleChangeNewEmail.bind(this)}>
										</input>
									</div>
									<div className="content__form-errmsg" id="J-errdisplay-newemail">
										{this.getNewEmailError()}
									</div>
									<div className="content__form-input">
										<input type="email" className="content__form-input-widget J-validated-field"
											placeholder={trans('confirm_email_placeholder')}
											onChange={this.handleChangeConfirmEmail.bind(this)}>
										</input>
									</div>
									<div className="content__form-errmsg" id="J-errdisplay-confirmemail">
										{this.getConfirmEmailError()}
									</div>
									<div className="content__form-input">
										<input type="password" className="content__form-input-widget J-validated-field"
											placeholder={trans('current_password_placeholder')}
											onChange={this.handleChangeCurrentPassword.bind(this)}>
										</input>
									</div>
									<div className="content__form-errmsg" id="J-errdisplay-curpwd">
										{this.getPasswordError()}
									</div>
									<div className="content__submit-wrap">
										<input type="submit" className="content__submit" value={trans('update_action')}/>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		userInfo: state.data.userInfo,
		email: state.email,
		language: state.data.language
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(Object.assign({}, emailActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangeEmail);


// WEBPACK FOOTER //
// ./app/components/security/email/SaveEmail.js